<div class="center-stage">
  <h1>Please Log On</h1>
  <p class="lead">Please log on using the menu above to get the fun started.</p>
</div>